"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "loading loading-2x"
};
const _hoisted_2 = { class: "settings-card-container accordion settings-accordion" };
const _hoisted_3 = { class: "settings-title-wrapper accordion-header c-hand" };
const _hoisted_4 = { class: "page-title-text" };
const _hoisted_5 = { key: 0 };
const _hoisted_6 = { class: "accordion-body" };
const _hoisted_7 = { class: "settings-item" };
const _hoisted_8 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_9 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_10 = { class: "settings-input oplus-form-switch" };
const _hoisted_11 = {
    key: 0,
    class: "settings-item"
};
const _hoisted_12 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_13 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_14 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_15 = {
    key: 1,
    class: "settings-item"
};
const _hoisted_16 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_17 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_18 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_19 = {
    key: 2,
    class: "settings-item"
};
const _hoisted_20 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_21 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_22 = { class: "settings-input oplus-form-switch" };
const _hoisted_23 = { class: "settings-item" };
const _hoisted_24 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_25 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_26 = { class: "settings-input oplus-form-switch" };
const _hoisted_27 = { class: "settings-item" };
const _hoisted_28 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_29 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_30 = { class: "settings-input oplus-form-switch" };
const _hoisted_31 = { class: "settings-item" };
const _hoisted_32 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_33 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_34 = { class: "settings-input oplus-form-switch" };
const _hoisted_35 = { class: "settings-item" };
const _hoisted_36 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_37 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_38 = { class: "d-flex flex-wrap settings-input" };
const _hoisted_39 = { class: "oplus-form-radio" };
const _hoisted_40 = { class: "oplus-form-radio" };
const _hoisted_41 = {
    key: 3,
    class: "settings-item settings-item-wrap"
};
const _hoisted_42 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_43 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_44 = { class: "settings-input oplus-form-switch" };
const _hoisted_45 = {
    key: 0,
    class: "overtime-start-time-sub d-flex flex-center"
};
const _hoisted_46 = { class: "oplus-form-radio oplus-form-radio-reverse" };
const _hoisted_47 = { class: "flex-centered flex-justify-between" };
const _hoisted_48 = { class: "schedule-length-dropdown-middle" };
const _hoisted_49 = { class: "schedule-length-dropdown-middle-input-container" };
const _hoisted_50 = ["value"];
const _hoisted_51 = { class: "schedule-length-dropdown-middle-input-container" };
const _hoisted_52 = { class: "oplus-form-radio" };
const _hoisted_53 = { class: "settings-item" };
const _hoisted_54 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_55 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_56 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_57 = { class: "settings-item" };
const _hoisted_58 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_59 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_60 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_61 = { class: "settings-item" };
const _hoisted_62 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_63 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_64 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_65 = { class: "settings-item" };
const _hoisted_66 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_67 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_68 = { class: "d-flex flex-wrap settings-input justify-content-end flex-column" };
const _hoisted_69 = { class: "oplus-form-radio" };
const _hoisted_70 = { class: "oplus-form-radio" };
const _hoisted_71 = { class: "oplus-form-radio" };
const _hoisted_72 = { class: "settings-item" };
const _hoisted_73 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_74 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_75 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_76 = { class: "oplus-form-checkbox" };
const _hoisted_77 = { class: "oplus-form-checkbox" };
const _hoisted_78 = { class: "oplus-form-checkbox" };
const _hoisted_79 = { class: "oplus-form-checkbox" };
const _hoisted_80 = { class: "settings-item" };
const _hoisted_81 = { class: "d-flex flex-wrap justify-content-end settings-input" };
const _hoisted_82 = { class: "oplus-form-checkbox" };
const _hoisted_83 = ["checked"];
const _hoisted_84 = { class: "oplus-form-checkbox" };
const _hoisted_85 = ["checked"];
const _hoisted_86 = { class: "oplus-form-checkbox" };
const _hoisted_87 = ["checked"];
const _hoisted_88 = { class: "oplus-form-checkbox" };
const _hoisted_89 = ["checked"];
const _hoisted_90 = { class: "oplus-form-checkbox" };
const _hoisted_91 = ["checked"];
const _hoisted_92 = { class: "oplus-form-checkbox" };
const _hoisted_93 = ["checked"];
const _hoisted_94 = { class: "oplus-form-checkbox" };
const _hoisted_95 = ["checked"];
const _hoisted_96 = { class: "settings-item" };
const _hoisted_97 = { class: "settings-multi-input settings-input w-40" };
const _hoisted_98 = { class: "settings-multi-item" };
const _hoisted_99 = { class: "oplus-form-checkbox" };
const _hoisted_100 = { class: "settings-multi-item" };
const _hoisted_101 = { class: "oplus-form-checkbox" };
const _hoisted_102 = { class: "settings-multi-item" };
const _hoisted_103 = { class: "oplus-form-checkbox" };
const _hoisted_104 = { class: "settings-multi-item" };
const _hoisted_105 = { class: "oplus-form-checkbox" };
const _hoisted_106 = { class: "settings-multi-item" };
const _hoisted_107 = { class: "oplus-form-checkbox" };
const _hoisted_108 = { class: "settings-item" };
const _hoisted_109 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_110 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_111 = { class: "settings-multi-input settings-input" };
const _hoisted_112 = { class: "settings-multi-item" };
const _hoisted_113 = { class: "oplus-form-checkbox" };
const _hoisted_114 = { class: "settings-multi-item" };
const _hoisted_115 = { class: "oplus-form-checkbox" };
const _hoisted_116 = { class: "settings-multi-item" };
const _hoisted_117 = { class: "oplus-form-checkbox" };
const _hoisted_118 = { class: "settings-multi-item" };
const _hoisted_119 = { class: "oplus-form-checkbox" };
const _hoisted_120 = { class: "settings-multi-item" };
const _hoisted_121 = { class: "oplus-form-checkbox" };
const _hoisted_122 = { class: "settings-multi-item" };
const _hoisted_123 = { class: "oplus-form-checkbox" };
const _hoisted_124 = { class: "settings-item" };
const _hoisted_125 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_126 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_127 = { class: "settings-multi-input settings-input" };
const _hoisted_128 = { class: "settings-multi-item" };
const _hoisted_129 = { class: "oplus-form-checkbox" };
const _hoisted_130 = { class: "settings-multi-item" };
const _hoisted_131 = { class: "oplus-form-checkbox" };
const _hoisted_132 = { class: "settings-multi-item" };
const _hoisted_133 = { class: "oplus-form-checkbox" };
const _hoisted_134 = { class: "settings-multi-item" };
const _hoisted_135 = { class: "oplus-form-checkbox" };
const _hoisted_136 = { class: "settings-multi-item" };
const _hoisted_137 = { class: "oplus-form-checkbox" };
const _hoisted_138 = { class: "settings-multi-item" };
const _hoisted_139 = { class: "oplus-form-checkbox" };
const _hoisted_140 = { class: "settings-item" };
const _hoisted_141 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_142 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_143 = { class: "settings-input oplus-form-switch" };
const _hoisted_144 = { class: "settings-item" };
const _hoisted_145 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_146 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_147 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_148 = { class: "settings-item" };
const _hoisted_149 = { class: "d-flex flex-wrap justify-content-end settings-input" };
const _hoisted_150 = { class: "oplus-form-radio" };
const _hoisted_151 = ["value"];
const _hoisted_152 = { class: "oplus-form-radio" };
const _hoisted_153 = ["value"];
const _hoisted_154 = { class: "oplus-form-radio" };
const _hoisted_155 = ["value"];
const _hoisted_156 = { class: "oplus-form-radio" };
const _hoisted_157 = ["value"];
const _hoisted_158 = { class: "oplus-form-radio" };
const _hoisted_159 = ["value"];
const _hoisted_160 = { class: "oplus-form-radio" };
const _hoisted_161 = ["value"];
const _hoisted_162 = { class: "oplus-form-radio" };
const _hoisted_163 = ["value"];
const _hoisted_164 = { class: "settings-item" };
const _hoisted_165 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_166 = ["value"];
const _hoisted_167 = ["value"];
const _hoisted_168 = { class: "settings-item" };
const _hoisted_169 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_170 = ["value"];
const _hoisted_171 = { class: "settings-item" };
const _hoisted_172 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_173 = ["value"];
const _hoisted_174 = { class: "settings-item" };
const _hoisted_175 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_176 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_177 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_178 = { class: "settings-item" };
const _hoisted_179 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_180 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_181 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_182 = { class: "settings-item" };
const _hoisted_183 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_184 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_185 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_186 = { class: "settings-item" };
const _hoisted_187 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_188 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_189 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_190 = { class: "settings-item" };
const _hoisted_191 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_192 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_193 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_194 = { class: "settings-item" };
const _hoisted_195 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_196 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_197 = { class: "d-flex flex-gap flex-wrap margin-left-auto" };
const _hoisted_198 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_199 = ["value"];
const _hoisted_200 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_201 = ["value"];
const _hoisted_202 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_203 = ["value"];
const _hoisted_204 = { class: "settings-item" };
const _hoisted_205 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_206 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_207 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_208 = ["value"];
const _hoisted_209 = { class: "settings-item" };
const _hoisted_210 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_211 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_212 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_213 = ["value"];
const _hoisted_214 = { class: "settings-item" };
const _hoisted_215 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_216 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_217 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_218 = ["value"];
const _hoisted_219 = { class: "settings-item" };
const _hoisted_220 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_221 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_222 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_223 = ["value"];
const _hoisted_224 = {
    key: 4,
    class: "settings-item"
};
const _hoisted_225 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_226 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_227 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_228 = { class: "labor-day-input-group" };
const _hoisted_229 = ["value"];
const _hoisted_230 = {
    key: 5,
    class: "settings-item"
};
const _hoisted_231 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_232 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_233 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_234 = { class: "labor-day-input-group" };
const _hoisted_235 = ["value"];
const _hoisted_236 = {
    key: 6,
    class: "settings-item"
};
const _hoisted_237 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_238 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_239 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_240 = { class: "labor-day-input-group" };
const _hoisted_241 = ["value"];
const _hoisted_242 = {
    key: 7,
    class: "settings-item"
};
const _hoisted_243 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_244 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_245 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_246 = {
    key: 8,
    class: "settings-item"
};
const _hoisted_247 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_248 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_249 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_250 = {
    key: 9,
    class: "settings-item settings-item-wrap"
};
const _hoisted_251 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_252 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_253 = { class: "settings-input oplus-form-switch" };
const _hoisted_254 = {
    key: 0,
    class: "overtime-start-time-sub d-flex flex-center"
};
const _hoisted_255 = { class: "oplus-form-checkbox show-overtime-start-time-checkbox" };
const _hoisted_256 = ["value"];
const _hoisted_257 = {
    key: 0,
    class: "settings-card-container accordion settings-accordion"
};
const _hoisted_258 = { class: "settings-title-wrapper accordion-header c-hand" };
const _hoisted_259 = { class: "accordion-body" };
const _hoisted_260 = { class: "settings-item" };
const _hoisted_261 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_262 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_263 = { class: "settings-input oplus-form-switch" };
const _hoisted_264 = { class: "settings-item" };
const _hoisted_265 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_266 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_267 = { class: "settings-input oplus-form-switch" };
const _hoisted_268 = { class: "settings-item" };
const _hoisted_269 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_270 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_271 = { class: "settings-input oplus-form-switch" };
const _hoisted_272 = { class: "settings-item" };
const _hoisted_273 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_274 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_275 = { class: "settings-input oplus-form-switch" };
const _hoisted_276 = { class: "settings-card-container accordion settings-accordion" };
const _hoisted_277 = { class: "accordion-body" };
const _hoisted_278 = { class: "settings-item" };
const _hoisted_279 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_280 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_281 = { class: "settings-input oplus-form-switch" };
const _hoisted_282 = { class: "settings-item" };
const _hoisted_283 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_284 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_285 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_286 = { class: "settings-item" };
const _hoisted_287 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_288 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_289 = {
    key: 0,
    class: "pro-label auto-label ml-2"
};
const _hoisted_290 = { class: "settings-item" };
const _hoisted_291 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_292 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_293 = {
    key: 0,
    class: "pro-label auto-label ml-2"
};
const _hoisted_294 = { class: "settings-item" };
const _hoisted_295 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_296 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_297 = {
    key: 0,
    class: "pro-label auto-label ml-2"
};
const _hoisted_298 = {
    key: 0,
    class: "settings-item"
};
const _hoisted_299 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_300 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_301 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_302 = ["value"];
const _hoisted_303 = { class: "settings-submit-button-wrapper" };
const vue_3 = require("vue");
const ShiftManagementIcon_vue_1 = __importDefault(require("../icons/ShiftManagementIcon.vue"));
const PlanManagementIcon_vue_1 = __importDefault(require("../icons/PlanManagementIcon.vue"));
const InfoIcon_vue_1 = __importDefault(require("../icons/InfoIcon.vue"));
const common_1 = require("../../common/common");
const dateInt_1 = __importDefault(require("../../common/dateInt"));
const settings_1 = require("../../js/settings");
const CalendarIcon_vue_1 = __importDefault(require("../icons/CalendarIcon.vue"));
const XIcon_vue_1 = __importDefault(require("../icons/XIcon.vue"));
const timeZones_1 = __importDefault(require("../../common/timeZones"));
const SCHEDULE_DROPDOWN_VIEWPORT_MARGIN = 8;
exports.default = (0, vue_1.defineComponent)({
    __name: 'SettingsShiftContent',
    props: {
        shiftSettings: {
            type: Object,
            required: true,
        },
        permissions: {
            type: Object,
            required: true,
        },
        branchCanEditSettings: {
            type: Boolean,
            default: true,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        isUpdating: {
            type: Boolean,
            default: false,
        },
        isDefaultSettingsPage: {
            type: Boolean,
            default: false,
        },
        selectedOem: {
            type: Number,
            required: true,
        },
        showTzSetting: {
            type: Boolean,
            default: false,
        }
    },
    emits: ["emit-shift-settings", "emit-open-branch-max-labor-modal"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const savedSettings = (0, vue_3.ref)("");
        const { hasProPerm, hasAutoPerm, hasTrialPerm } = props.permissions;
        const disabledBtn = (0, vue_3.computed)(() => {
            return !hasTrialPerm && !hasProPerm ? 'disabled-btn' : '';
        });
        const disabledAuto = (0, vue_3.computed)(() => {
            return !hasAutoPerm ? 'disabled-btn' : '';
        });
        const localSettingShiftLockDate = (0, vue_3.ref)({
            shiftLockYear: 0,
            shiftLockMonth: 0,
            shiftLockDay: 0,
        });
        const localSettingsData = (0, vue_3.ref)({ ...props.shiftSettings });
        const scheduleLength = (0, vue_3.computed)({
            get: () => localSettingsData.value.scheduleLength ?? 0,
            set: (v) => { localSettingsData.value.scheduleLength = v; },
        });
        const scheduleDropdownOpen = (0, vue_3.ref)(false);
        const scheduleDropdownContainer = (0, vue_3.ref)(null);
        const scheduleDropdownEl = (0, vue_3.ref)(null);
        const scheduleDropdownStyle = (0, vue_3.ref)({});
        function updateScheduleDropdownPosition() {
            const container = scheduleDropdownContainer.value;
            const dropdown = scheduleDropdownEl.value;
            if (!container || !dropdown) {
                return;
            }
            const containerRect = container.getBoundingClientRect();
            const dropdownWidth = dropdown.getBoundingClientRect().width;
            const centeredLeft = containerRect.left + containerRect.width / 2 - dropdownWidth / 2;
            const minLeft = SCHEDULE_DROPDOWN_VIEWPORT_MARGIN;
            const maxLeft = window.innerWidth - dropdownWidth - SCHEDULE_DROPDOWN_VIEWPORT_MARGIN;
            const clampedLeft = Math.min(Math.max(centeredLeft, minLeft), maxLeft);
            scheduleDropdownStyle.value = {
                left: `${clampedLeft - containerRect.left}px`,
                transform: 'none',
            };
        }
        (0, vue_3.watch)(scheduleDropdownOpen, (isOpen) => {
            if (isOpen) {
                (0, vue_3.nextTick)(updateScheduleDropdownPosition);
                window.addEventListener('resize', updateScheduleDropdownPosition);
            }
            else {
                window.removeEventListener('resize', updateScheduleDropdownPosition);
            }
        });
        function handleScheduleDropdownBlur(e) {
            if (!e.currentTarget.contains(e.relatedTarget)) {
                scheduleDropdownOpen.value = false;
            }
        }
        const scheduleStartDateInputEl = (0, vue_3.ref)(null);
        function openScheduleStartDatePicker() {
            const input = scheduleStartDateInputEl.value;
            if (!input) {
                return;
            }
            if (typeof input.showPicker === 'function') {
                input.showPicker();
            }
            else {
                input.focus();
            }
        }
        function handleScheduleDropdownClear() {
            localSettingsData.value.scheduleLength = 0;
            localSettingsData.value.scheduleStartDate = new Date(0);
        }
        function handleScheduleDropdownConfirm() {
            scheduleDropdownOpen.value = false;
            emit("emit-shift-settings", localSettingsData);
        }
        const shiftNotification = (0, vue_3.computed)({
            get: () => {
                return (0, common_1.durationToKitchenTime)(localSettingsData.value.shiftNotification, "minutes");
            },
            set: (value) => {
                localSettingsData.value.shiftNotification = (0, common_1.kitchenTimeToDuration)(value, "minutes");
            }
        });
        const shiftInterval = (0, vue_3.computed)({
            get: () => {
                return (0, common_1.durationToKitchenTime)(localSettingsData.value.shiftInterval, "minutes");
            },
            set: (value) => {
                localSettingsData.value.shiftInterval = (0, common_1.kitchenTimeToDuration)(value, "minutes");
            }
        });
        const scheduleStartDateInput = (0, vue_3.computed)({
            get: () => {
                const date = localSettingsData.value.scheduleStartDate;
                return date && date.getTime() !== 0 ? (0, common_1.yearMonthDateString)((0, common_1.fromOplusTime)(date), timeZones_1.default.ASIA_TOKYO) : "";
            },
            set: (value) => {
                localSettingsData.value.scheduleStartDate = value ? (0, common_1.toOplusTime)((0, common_1.dateFromString)(value, timeZones_1.default.ASIA_TOKYO)) : new Date(0);
            }
        });
        const loadingClass = (0, vue_3.computed)(() => {
            return {
                "loading": props.isUpdating,
            };
        });
        const disabledPage = (0, vue_3.computed)(() => {
            return {
                'disabled-page': !props.branchCanEditSettings,
            };
        });
        function getCurrentSettingsData() {
            return JSON.stringify({
                settings: localSettingsData.value,
                shiftLockDateInput: localSettingShiftLockDate.value,
            });
        }
        function handleMaxConsecutiveWorkdays(e) {
            const newVal = (0, settings_1.convertInputValToInt)(e);
            localSettingsData.value.maxConsecutiveWorkdays = newVal;
        }
        function handleMaxConsecutiveDaysOff(e) {
            const newVal = (0, settings_1.convertInputValToInt)(e);
            localSettingsData.value.maxConsecutiveDaysOff = newVal;
        }
        function handleStartOfMonthChange(e) {
            const newVal = (0, settings_1.convertInputValToInt)(e);
            localSettingsData.value.monthStart = newVal;
        }
        function handleStartOfYearChange(e) {
            const newVal = (0, settings_1.convertInputValToInt)(e);
            localSettingsData.value.yearStart = newVal;
        }
        function handleSummaryDayStartChange(e) {
            const newVal = (0, settings_1.convertInputValToInt)(e);
            localSettingsData.value.summaryDayStart = newVal;
        }
        function handleSummaryDayEndChange(e) {
            let newVal = (0, settings_1.convertInputValToInt)(e);
            localSettingsData.value.summaryDayEnd = newVal;
        }
        function handleShiftLockYearChange(e) {
            let newVal = (0, settings_1.convertInputValToInt)(e);
            if (!newVal) {
                newVal = localSettingShiftLockDate.value.shiftLockYear;
            }
            localSettingShiftLockDate.value.shiftLockYear = newVal;
        }
        function handleShiftLockMonthChange(e) {
            const newVal = (0, settings_1.convertInputValToInt)(e);
            localSettingShiftLockDate.value.shiftLockMonth = newVal;
        }
        function handleShiftLockDayChange(e) {
            const newVal = (0, settings_1.convertInputValToInt)(e);
            localSettingShiftLockDate.value.shiftLockDay = newVal;
        }
        function splitShiftLockDate() {
            const shiftLockDate = localSettingsData.value.shiftLockDate;
            if (shiftLockDate) {
                localSettingShiftLockDate.value.shiftLockYear = shiftLockDate.getFullYear();
                localSettingShiftLockDate.value.shiftLockMonth = shiftLockDate.getMonth() + 1;
                localSettingShiftLockDate.value.shiftLockDay = shiftLockDate.getDate();
            }
            else {
                localSettingShiftLockDate.value.shiftLockYear = new Date().getFullYear();
                localSettingShiftLockDate.value.shiftLockMonth = null;
                localSettingShiftLockDate.value.shiftLockDay = null;
            }
        }
        function makeShiftLockDate() {
            const lockYear = localSettingShiftLockDate.value.shiftLockYear;
            const lockMonth = localSettingShiftLockDate.value.shiftLockMonth;
            const lockDay = localSettingShiftLockDate.value.shiftLockDay;
            if (lockYear && lockMonth && lockDay) {
                localSettingsData.value.shiftLockDate = new Date(lockYear, lockMonth - 1, lockDay);
            }
            else {
                localSettingsData.value.shiftLockDate = undefined;
            }
        }
        function handleOvertimeHoursInput(e) {
            localSettingsData.value.overtimeStartTimeHours = Number(e.target.value);
        }
        function handleCloseDaysChange(e, index) {
            const target = e.target;
            if (target && 'checked' in target) {
                localSettingsData.value.closedWeekdays[index] = target.checked;
                return;
            }
            return localSettingsData.value.closedWeekdays[index] = false;
        }
        const emit = __emit;
        function handleCalendarClick() {
            emit("emit-open-branch-max-labor-modal");
        }
        function getSettingsForSubmit() {
            if (!props.branchCanEditSettings) {
                return null;
            }
            makeShiftLockDate();
            if (localSettingsData.value.summaryDayStart >= localSettingsData.value.summaryDayEnd) {
                (0, settings_1.importAlertModal)().alert("invalid time on 就業時間設定, start time should be less than the end time");
                return null;
            }
            return localSettingsData.value;
        }
        function handleShiftSubmit() {
            const settings = getSettingsForSubmit();
            if (!settings) {
                return;
            }
            emit("emit-shift-settings", localSettingsData);
        }
        function hasUnsavedChanges() {
            return getCurrentSettingsData() !== savedSettings.value;
        }
        function updateSaved() {
            savedSettings.value = getCurrentSettingsData();
        }
        __expose({
            hasUnsavedChanges,
            getSettingsForSubmit,
            updateSaved,
        });
        function onScheduleCustomIconClick() {
            if (localSettingsData.value.scheduleCustomEnabled) {
                scheduleDropdownOpen.value = !scheduleDropdownOpen.value;
            }
        }
        (0, vue_3.watch)(() => props.shiftSettings, (newSettings) => {
            localSettingsData.value = newSettings;
            splitShiftLockDate();
            updateSaved();
        }, { immediate: true }); // we want to fetch the initial data, and then re-fetch the data whenever relevant state changes.
        return (_ctx, _cache) => {
            return (__props.isLoading)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1))
                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                    key: 1,
                    ref: "settingsContainer",
                    class: (0, vue_2.normalizeClass)(["main-settings-container", disabledPage.value])
                }, [
                    (0, vue_2.createElementVNode)("details", _hoisted_2, [
                        (0, vue_2.createCommentVNode)(" Summary page settings "),
                        (0, vue_2.createElementVNode)("summary", _hoisted_3, [
                            _cache[85] || (_cache[85] = (0, vue_2.createElementVNode)("i", { class: "icon icon-arrow-right" }, null, -1 /* CACHED */)),
                            (0, vue_2.createVNode)(ShiftManagementIcon_vue_1.default, { class: "page-title-text settings-accordion-icon" }),
                            (0, vue_2.createElementVNode)("span", _hoisted_4, [
                                _cache[84] || (_cache[84] = (0, vue_2.createTextVNode)(" シフト管理 ", -1 /* CACHED */)),
                                (__props.isDefaultSettingsPage)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("small", _hoisted_5, "（デフォルト設定）"))
                                    : (0, vue_2.createCommentVNode)("v-if", true)
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_6, [
                            (0, vue_2.createCommentVNode)(" canView "),
                            (0, vue_2.createElementVNode)("div", _hoisted_7, [
                                (0, vue_2.createElementVNode)("div", _hoisted_8, [
                                    _cache[87] || (_cache[87] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "シフト表", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_9, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[86] || (_cache[86] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "全スタッフに「シフト管理」の閲覧権限を付与する。")
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_10, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((localSettingsData.value.staffCanViewSummary) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.staffCanViewSummary]
                                    ]),
                                    _cache[88] || (_cache[88] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" ProfilePhotoEnabled "),
                            (__props.isDefaultSettingsPage)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_11, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_12, [
                                        _cache[90] || (_cache[90] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "プロフィール画像", -1 /* CACHED */)),
                                        (0, vue_2.createElementVNode)("div", _hoisted_13, [
                                            (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                            _cache[89] || (_cache[89] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                                (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "プロフィール画像を利用する")
                                            ], -1 /* CACHED */))
                                        ])
                                    ]),
                                    (!(0, vue_2.unref)(hasProPerm))
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_14))
                                        : (0, vue_2.createCommentVNode)("v-if", true),
                                    (0, vue_2.createElementVNode)("label", {
                                        class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledBtn.value])
                                    }, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((localSettingsData.value.profilePhotoEnabled) = $event)),
                                            type: "checkbox"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelCheckbox, localSettingsData.value.profilePhotoEnabled]
                                        ]),
                                        _cache[91] || (_cache[91] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                    ], 2 /* CLASS */)
                                ]))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            (0, vue_2.createCommentVNode)(" ShowWageRelatedForNonOwners "),
                            (__props.isDefaultSettingsPage)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_15, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_16, [
                                        _cache[93] || (_cache[93] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "労務の閲覧・編集権限", -1 /* CACHED */)),
                                        (0, vue_2.createElementVNode)("div", _hoisted_17, [
                                            (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                            _cache[92] || (_cache[92] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                                (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "シフト編集者に交通費・労務費・人件費の閲覧権限、時給の編集権限を付与する")
                                            ], -1 /* CACHED */))
                                        ])
                                    ]),
                                    (!(0, vue_2.unref)(hasProPerm))
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_18))
                                        : (0, vue_2.createCommentVNode)("v-if", true),
                                    (0, vue_2.createElementVNode)("label", {
                                        class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledBtn.value])
                                    }, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((localSettingsData.value.showWageRelatedForNonOwners) = $event)),
                                            type: "checkbox"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelCheckbox, localSettingsData.value.showWageRelatedForNonOwners]
                                        ]),
                                        _cache[94] || (_cache[94] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                    ], 2 /* CLASS */)
                                ]))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            (0, vue_2.createCommentVNode)(" Confirm Shift Borders "),
                            (__props.isDefaultSettingsPage)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_19, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_20, [
                                        _cache[96] || (_cache[96] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "確定", -1 /* CACHED */)),
                                        (0, vue_2.createElementVNode)("div", _hoisted_21, [
                                            (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                            _cache[95] || (_cache[95] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                                (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "確定前のシフトに枠線を使用する")
                                            ], -1 /* CACHED */))
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_22, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((localSettingsData.value.confirmShiftBorder) = $event)),
                                            type: "checkbox"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelCheckbox, localSettingsData.value.confirmShiftBorder]
                                        ]),
                                        _cache[97] || (_cache[97] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                    ])
                                ]))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            (0, vue_2.createCommentVNode)(" splitNightShift "),
                            (0, vue_2.createElementVNode)("div", _hoisted_23, [
                                (0, vue_2.createElementVNode)("div", _hoisted_24, [
                                    _cache[99] || (_cache[99] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "日跨ぎ設定", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_25, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[98] || (_cache[98] = (0, vue_2.createStaticVNode)("<div class=\"tooltip-wrapper\" data-v-30f9a4bc><span class=\"tooltip-text\" data-v-30f9a4bc>日を跨ぐシフトを2日に分ける。 <div class=\"split-slot-settings-sample\" data-v-30f9a4bc><table class=\"split-table\" data-v-30f9a4bc><thead data-v-30f9a4bc><tr data-v-30f9a4bc><th class=\"split-table-header\" data-v-30f9a4bc>1月1日</th></tr></thead><tbody class=\"split-table-body\" data-v-30f9a4bc><tr data-v-30f9a4bc><td data-v-30f9a4bc><div class=\"split-slot-chip\" data-v-30f9a4bc><span data-v-30f9a4bc>レジ</span><span data-v-30f9a4bc>20:00 ~ 5:00</span></div></td></tr></tbody></table><!-- Arrow here --><i class=\"zmdi zmdi-arrow-right zmdi-hc-lg\" data-v-30f9a4bc></i><table class=\"split-table\" data-v-30f9a4bc><thead data-v-30f9a4bc><tr data-v-30f9a4bc><th class=\"split-table-header\" data-v-30f9a4bc>1月1日</th><th class=\"split-table-header\" data-v-30f9a4bc>1月2日</th></tr></thead><tbody class=\"split-table-body\" data-v-30f9a4bc><tr data-v-30f9a4bc><td data-v-30f9a4bc><div class=\"split-slot-chip\" data-v-30f9a4bc><span data-v-30f9a4bc>レジ</span><span data-v-30f9a4bc>20:00 ~ 23:59</span></div></td><td data-v-30f9a4bc><div class=\"split-slot-chip\" data-v-30f9a4bc><span data-v-30f9a4bc>レジ</span><span data-v-30f9a4bc>24:00 ~ 5:00</span></div></td></tr></tbody></table></div></span></div>", 1))
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_26, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((localSettingsData.value.splitNightShift) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.splitNightShift]
                                    ]),
                                    _cache[100] || (_cache[100] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" stackedRequest "),
                            (0, vue_2.createElementVNode)("div", _hoisted_27, [
                                (0, vue_2.createElementVNode)("div", _hoisted_28, [
                                    _cache[102] || (_cache[102] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "希望シフト", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_29, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[101] || (_cache[101] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, [
                                                (0, vue_2.createTextVNode)(" スタッフの希望と変更したシフトの両方を見れる機能。 "),
                                                (0, vue_2.createElementVNode)("span", null, "本機能をONにすると:"),
                                                (0, vue_2.createElementVNode)("br"),
                                                (0, vue_2.createElementVNode)("span", null, "-「戻す」ボタンが非表示となります。"),
                                                (0, vue_2.createElementVNode)("br"),
                                                (0, vue_2.createElementVNode)("span", null, "- シフトをロックされている場合、スタッフはシフト提出ページで提出したシフトのみ閲覧できます。")
                                            ])
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_30, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((localSettingsData.value.stackedRequest) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.stackedRequest]
                                    ]),
                                    _cache[103] || (_cache[103] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" showRoles "),
                            (0, vue_2.createElementVNode)("div", _hoisted_31, [
                                (0, vue_2.createElementVNode)("div", _hoisted_32, [
                                    _cache[105] || (_cache[105] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "業務", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_33, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[104] || (_cache[104] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "業務一覧を表示する。")
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_34, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((localSettingsData.value.showRoles) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.showRoles]
                                    ]),
                                    _cache[106] || (_cache[106] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" defaultView "),
                            (0, vue_2.createElementVNode)("div", _hoisted_35, [
                                (0, vue_2.createElementVNode)("div", _hoisted_36, [
                                    _cache[108] || (_cache[108] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "デフォルト", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_37, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[107] || (_cache[107] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "デフォルトで表示される全体のシフト表")
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_38, [
                                    (0, vue_2.createElementVNode)("label", _hoisted_39, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((localSettingsData.value.defaultView) = $event)),
                                            value: 0,
                                            type: "radio",
                                            name: "default-summary-view"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelRadio, localSettingsData.value.defaultView]
                                        ]),
                                        _cache[109] || (_cache[109] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */)),
                                        _cache[110] || (_cache[110] = (0, vue_2.createElementVNode)("span", null, "週", -1 /* CACHED */))
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_40, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((localSettingsData.value.defaultView) = $event)),
                                            value: 1,
                                            type: "radio",
                                            name: "default-summary-view"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelRadio, localSettingsData.value.defaultView]
                                        ]),
                                        _cache[111] || (_cache[111] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */)),
                                        _cache[112] || (_cache[112] = (0, vue_2.createElementVNode)("span", null, "月", -1 /* CACHED */))
                                    ])
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" operational phases "),
                            (__props.isDefaultSettingsPage)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_41, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_42, [
                                        _cache[114] || (_cache[114] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "スケジュール", -1 /* CACHED */)),
                                        (0, vue_2.createElementVNode)("div", _hoisted_43, [
                                            (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                            _cache[113] || (_cache[113] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                                (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "会社のニーズに最適なスケジュール期間を定義する")
                                            ], -1 /* CACHED */))
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_44, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((localSettingsData.value.scheduleEnabled) = $event)),
                                            type: "checkbox"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelCheckbox, localSettingsData.value.scheduleEnabled]
                                        ]),
                                        _cache[115] || (_cache[115] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                    ]),
                                    (localSettingsData.value.scheduleEnabled)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_45, [
                                            (0, vue_2.createElementVNode)("label", _hoisted_46, [
                                                _cache[116] || (_cache[116] = (0, vue_2.createElementVNode)("span", null, "カスタム範囲を設定する", -1 /* CACHED */)),
                                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((localSettingsData.value.scheduleCustomEnabled) = $event)),
                                                    value: true,
                                                    type: "radio",
                                                    name: "schedule-custom-radio",
                                                    onChange: _cache[11] || (_cache[11] = ($event) => (scheduleDropdownOpen.value = true))
                                                }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                                    [vue_2.vModelRadio, localSettingsData.value.scheduleCustomEnabled]
                                                ]),
                                                _cache[117] || (_cache[117] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                            ]),
                                            (0, vue_2.createElementVNode)("div", {
                                                ref_key: "scheduleDropdownContainer",
                                                ref: scheduleDropdownContainer,
                                                class: "schedule-length-dropdown-container",
                                                tabindex: "0",
                                                onFocusout: handleScheduleDropdownBlur
                                            }, [
                                                (0, vue_2.createVNode)(CalendarIcon_vue_1.default, {
                                                    class: "c-hand calendar-icon",
                                                    onClick: onScheduleCustomIconClick
                                                }),
                                                (0, vue_2.createVNode)(vue_2.Transition, { name: "dropdown-shift" }, {
                                                    default: (0, vue_2.withCtx)(() => [
                                                        (scheduleDropdownOpen.value)
                                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                                key: 0,
                                                                ref_key: "scheduleDropdownEl",
                                                                ref: scheduleDropdownEl,
                                                                class: "schedule-length-dropdown",
                                                                style: (0, vue_2.normalizeStyle)(scheduleDropdownStyle.value)
                                                            }, [
                                                                (0, vue_2.createElementVNode)("div", _hoisted_47, [
                                                                    _cache[118] || (_cache[118] = (0, vue_2.createElementVNode)("span", null, "スケジュールの長さ", -1 /* CACHED */)),
                                                                    (0, vue_2.createElementVNode)("div", {
                                                                        class: "schedule-length-dropdown-close",
                                                                        onClick: _cache[12] || (_cache[12] = ($event) => (scheduleDropdownOpen.value = false))
                                                                    }, [
                                                                        (0, vue_2.createVNode)(XIcon_vue_1.default)
                                                                    ])
                                                                ]),
                                                                _cache[123] || (_cache[123] = (0, vue_2.createElementVNode)("hr", null, null, -1 /* CACHED */)),
                                                                (0, vue_2.createElementVNode)("div", _hoisted_48, [
                                                                    _cache[122] || (_cache[122] = (0, vue_2.createElementVNode)("p", null, "シフトサイクルの開始日と期間を設定してください。", -1 /* CACHED */)),
                                                                    (0, vue_2.createElementVNode)("div", _hoisted_49, [
                                                                        _cache[119] || (_cache[119] = (0, vue_2.createElementVNode)("label", { for: "schedule-length" }, "間隔", -1 /* CACHED */)),
                                                                        (0, vue_2.createElementVNode)("input", {
                                                                            value: scheduleLength.value || undefined,
                                                                            onInput: _cache[13] || (_cache[13] = ($event) => (scheduleLength.value = Number($event.target.value))),
                                                                            class: "form-input form-extra-small",
                                                                            placeholder: "0",
                                                                            name: "schedule-length"
                                                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_50),
                                                                        _cache[120] || (_cache[120] = (0, vue_2.createElementVNode)("span", { class: "input-postfix-text" }, "日", -1 /* CACHED */))
                                                                    ]),
                                                                    (0, vue_2.createElementVNode)("div", _hoisted_51, [
                                                                        _cache[121] || (_cache[121] = (0, vue_2.createElementVNode)("label", { for: "schedule-start" }, "開始日", -1 /* CACHED */)),
                                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                                            ref_key: "scheduleStartDateInputEl",
                                                                            ref: scheduleStartDateInputEl,
                                                                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((scheduleStartDateInput).value = $event)),
                                                                            class: "form-input form-extra-small",
                                                                            placeholder: "0",
                                                                            name: "schedule-start",
                                                                            type: "date"
                                                                        }, null, 512 /* NEED_PATCH */), [
                                                                            [vue_2.vModelText, scheduleStartDateInput.value]
                                                                        ]),
                                                                        (0, vue_2.createElementVNode)("span", {
                                                                            class: "input-postfix-text c-hand",
                                                                            onClick: openScheduleStartDatePicker
                                                                        }, [
                                                                            (0, vue_2.createVNode)(CalendarIcon_vue_1.default)
                                                                        ])
                                                                    ])
                                                                ]),
                                                                _cache[124] || (_cache[124] = (0, vue_2.createElementVNode)("hr", null, null, -1 /* CACHED */)),
                                                                (0, vue_2.createElementVNode)("div", { class: "flex-centered flex-justify-between" }, [
                                                                    (0, vue_2.createElementVNode)("button", {
                                                                        type: "button",
                                                                        class: "btn oplus-btn",
                                                                        onClick: handleScheduleDropdownClear
                                                                    }, "クリア"),
                                                                    (0, vue_2.createElementVNode)("button", {
                                                                        type: "button",
                                                                        class: "btn oplus-btn oplus-alt-btn",
                                                                        onClick: handleScheduleDropdownConfirm
                                                                    }, "確定")
                                                                ])
                                                            ], 4 /* STYLE */))
                                                            : (0, vue_2.createCommentVNode)("v-if", true)
                                                    ]),
                                                    _: 1 /* STABLE */
                                                })
                                            ], 544 /* NEED_HYDRATION, NEED_PATCH */),
                                            (0, vue_2.createElementVNode)("label", _hoisted_52, [
                                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((localSettingsData.value.scheduleCustomEnabled) = $event)),
                                                    value: false,
                                                    type: "radio",
                                                    name: "schedule-custom-radio",
                                                    onChange: _cache[16] || (_cache[16] = ($event) => (scheduleDropdownOpen.value = false))
                                                }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                                    [vue_2.vModelRadio, localSettingsData.value.scheduleCustomEnabled]
                                                ]),
                                                _cache[125] || (_cache[125] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */)),
                                                _cache[126] || (_cache[126] = (0, vue_2.createElementVNode)("span", null, "月", -1 /* CACHED */))
                                            ])
                                        ]))
                                        : (0, vue_2.createCommentVNode)("v-if", true)
                                ]))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            (0, vue_2.createCommentVNode)(" transportSummary "),
                            (0, vue_2.createElementVNode)("div", _hoisted_53, [
                                (0, vue_2.createElementVNode)("div", _hoisted_54, [
                                    _cache[128] || (_cache[128] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "別々の費用", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_55, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[127] || (_cache[127] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "シフト管理で交通費と労務費が別々に表示される。")
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (!(0, vue_2.unref)(hasProPerm))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_56))
                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                (0, vue_2.createElementVNode)("label", {
                                    class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledBtn.value])
                                }, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((localSettingsData.value.transportSummary) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.transportSummary]
                                    ]),
                                    _cache[129] || (_cache[129] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                ], 2 /* CLASS */)
                            ]),
                            (0, vue_2.createCommentVNode)(" memoSummary "),
                            (0, vue_2.createElementVNode)("div", _hoisted_57, [
                                (0, vue_2.createElementVNode)("div", _hoisted_58, [
                                    _cache[131] || (_cache[131] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "メモ", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_59, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[130] || (_cache[130] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "シフト管理でメモが表示される。")
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (!(0, vue_2.unref)(hasProPerm))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_60))
                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                (0, vue_2.createElementVNode)("label", {
                                    class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledBtn.value])
                                }, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((localSettingsData.value.memoSummary) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.memoSummary]
                                    ]),
                                    _cache[132] || (_cache[132] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                ], 2 /* CLASS */)
                            ]),
                            (0, vue_2.createCommentVNode)(" dwsSort "),
                            (0, vue_2.createElementVNode)("div", _hoisted_61, [
                                (0, vue_2.createElementVNode)("div", _hoisted_62, [
                                    _cache[134] || (_cache[134] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "日表示", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_63, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[133] || (_cache[133] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "カレンダーを日表示にした際に、出勤時間が早い人順に並べられる")
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (!(0, vue_2.unref)(hasProPerm))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_64))
                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                (0, vue_2.createElementVNode)("label", {
                                    class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledBtn.value])
                                }, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((localSettingsData.value.dwsSort) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.dwsSort]
                                    ]),
                                    _cache[135] || (_cache[135] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                ], 2 /* CLASS */)
                            ]),
                            (0, vue_2.createCommentVNode)(" showRoleTimes "),
                            (0, vue_2.createElementVNode)("div", _hoisted_65, [
                                (0, vue_2.createElementVNode)("div", _hoisted_66, [
                                    _cache[137] || (_cache[137] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "業務時間", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_67, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[136] || (_cache[136] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "業務管理で作成した業務の時間表記設定")
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_68, [
                                    (0, vue_2.createElementVNode)("label", _hoisted_69, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((localSettingsData.value.showRoleTimes) = $event)),
                                            value: 0,
                                            type: "radio",
                                            name: "show-role-times"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelRadio, localSettingsData.value.showRoleTimes]
                                        ]),
                                        _cache[138] || (_cache[138] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */)),
                                        _cache[139] || (_cache[139] = (0, vue_2.createElementVNode)("span", null, "表示しない", -1 /* CACHED */))
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_70, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => ((localSettingsData.value.showRoleTimes) = $event)),
                                            value: 1,
                                            type: "radio",
                                            name: "show-role-times"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelRadio, localSettingsData.value.showRoleTimes]
                                        ]),
                                        _cache[140] || (_cache[140] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */)),
                                        _cache[141] || (_cache[141] = (0, vue_2.createElementVNode)("span", null, "変更されたら表示", -1 /* CACHED */))
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_71, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => ((localSettingsData.value.showRoleTimes) = $event)),
                                            value: 2,
                                            type: "radio",
                                            name: "show-role-times"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelRadio, localSettingsData.value.showRoleTimes]
                                        ]),
                                        _cache[142] || (_cache[142] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */)),
                                        _cache[143] || (_cache[143] = (0, vue_2.createElementVNode)("span", null, "常に表示", -1 /* CACHED */))
                                    ])
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_72, [
                                (0, vue_2.createElementVNode)("div", _hoisted_73, [
                                    _cache[145] || (_cache[145] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "労務指標", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_74, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[144] || (_cache[144] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "労務の数値をシフト表に表示させる")
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (!(0, vue_2.unref)(hasProPerm))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_75))
                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                (0, vue_2.createElementVNode)("div", {
                                    class: (0, vue_2.normalizeClass)(["d-flex flex-wrap justify-content-end settings-input", disabledBtn.value])
                                }, [
                                    (0, vue_2.createElementVNode)("label", _hoisted_76, [
                                        (0, vue_2.createCommentVNode)(" isWorkCountInSummaryPage "),
                                        _cache[146] || (_cache[146] = (0, vue_2.createElementVNode)("span", null, "日数", -1 /* CACHED */)),
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event) => ((localSettingsData.value.isWorkCountInSummaryPage) = $event)),
                                            type: "checkbox"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelCheckbox, localSettingsData.value.isWorkCountInSummaryPage]
                                        ]),
                                        _cache[147] || (_cache[147] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                    ]),
                                    (0, vue_2.createCommentVNode)(" isVacationCountInSummaryPage "),
                                    (0, vue_2.createElementVNode)("label", _hoisted_77, [
                                        _cache[148] || (_cache[148] = (0, vue_2.createElementVNode)("span", null, "公休", -1 /* CACHED */)),
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event) => ((localSettingsData.value.isVacationCountInSummaryPage) = $event)),
                                            type: "checkbox"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelCheckbox, localSettingsData.value.isVacationCountInSummaryPage]
                                        ]),
                                        _cache[149] || (_cache[149] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                    ]),
                                    (0, vue_2.createCommentVNode)(" isLaborInSummaryPage "),
                                    (0, vue_2.createElementVNode)("label", _hoisted_78, [
                                        _cache[150] || (_cache[150] = (0, vue_2.createElementVNode)("span", null, "労働", -1 /* CACHED */)),
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event) => ((localSettingsData.value.isLaborInSummaryPage) = $event)),
                                            type: "checkbox"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelCheckbox, localSettingsData.value.isLaborInSummaryPage]
                                        ]),
                                        _cache[151] || (_cache[151] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                    ]),
                                    (0, vue_2.createCommentVNode)(" isPTOCountInSummaryPage "),
                                    (0, vue_2.createElementVNode)("label", _hoisted_79, [
                                        _cache[152] || (_cache[152] = (0, vue_2.createElementVNode)("span", null, "有休", -1 /* CACHED */)),
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event) => ((localSettingsData.value.isPTOCountInSummaryPage) = $event)),
                                            type: "checkbox"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelCheckbox, localSettingsData.value.isPTOCountInSummaryPage]
                                        ]),
                                        _cache[153] || (_cache[153] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                    ])
                                ], 2 /* CLASS */)
                            ]),
                            (0, vue_2.createCommentVNode)(" closedWeekdays "),
                            (0, vue_2.createElementVNode)("div", _hoisted_80, [
                                _cache[168] || (_cache[168] = (0, vue_2.createElementVNode)("div", { class: "settings-item-name-wrapper flex-center" }, [
                                    (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "定休日")
                                ], -1 /* CACHED */)),
                                (0, vue_2.createElementVNode)("div", _hoisted_81, [
                                    (0, vue_2.createElementVNode)("label", _hoisted_82, [
                                        _cache[154] || (_cache[154] = (0, vue_2.createElementVNode)("span", null, "日", -1 /* CACHED */)),
                                        (0, vue_2.createElementVNode)("input", {
                                            onChange: _cache[27] || (_cache[27] = ($event) => (handleCloseDaysChange($event, (0, vue_2.unref)(dateInt_1.default).SUN))),
                                            checked: localSettingsData.value.closedWeekdays[0],
                                            name: "weekday-start",
                                            type: "checkbox"
                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_83),
                                        _cache[155] || (_cache[155] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_84, [
                                        _cache[156] || (_cache[156] = (0, vue_2.createElementVNode)("span", null, "月", -1 /* CACHED */)),
                                        (0, vue_2.createElementVNode)("input", {
                                            onChange: _cache[28] || (_cache[28] = ($event) => (handleCloseDaysChange($event, (0, vue_2.unref)(dateInt_1.default).MON))),
                                            checked: localSettingsData.value.closedWeekdays[1],
                                            name: "weekday-start",
                                            type: "checkbox"
                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_85),
                                        _cache[157] || (_cache[157] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_86, [
                                        _cache[158] || (_cache[158] = (0, vue_2.createElementVNode)("span", null, "火", -1 /* CACHED */)),
                                        (0, vue_2.createElementVNode)("input", {
                                            onChange: _cache[29] || (_cache[29] = ($event) => (handleCloseDaysChange($event, (0, vue_2.unref)(dateInt_1.default).TUE))),
                                            checked: localSettingsData.value.closedWeekdays[2],
                                            name: "weekday-start",
                                            type: "checkbox"
                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_87),
                                        _cache[159] || (_cache[159] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_88, [
                                        _cache[160] || (_cache[160] = (0, vue_2.createElementVNode)("span", null, "水", -1 /* CACHED */)),
                                        (0, vue_2.createElementVNode)("input", {
                                            onChange: _cache[30] || (_cache[30] = ($event) => (handleCloseDaysChange($event, (0, vue_2.unref)(dateInt_1.default).WED))),
                                            checked: localSettingsData.value.closedWeekdays[3],
                                            name: "weekday-start",
                                            type: "checkbox"
                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_89),
                                        _cache[161] || (_cache[161] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_90, [
                                        _cache[162] || (_cache[162] = (0, vue_2.createElementVNode)("span", null, "木", -1 /* CACHED */)),
                                        (0, vue_2.createElementVNode)("input", {
                                            onChange: _cache[31] || (_cache[31] = ($event) => (handleCloseDaysChange($event, (0, vue_2.unref)(dateInt_1.default).THUR))),
                                            checked: localSettingsData.value.closedWeekdays[4],
                                            name: "weekday-start",
                                            type: "checkbox"
                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_91),
                                        _cache[163] || (_cache[163] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_92, [
                                        _cache[164] || (_cache[164] = (0, vue_2.createElementVNode)("span", null, "金", -1 /* CACHED */)),
                                        (0, vue_2.createElementVNode)("input", {
                                            onChange: _cache[32] || (_cache[32] = ($event) => (handleCloseDaysChange($event, (0, vue_2.unref)(dateInt_1.default).FRI))),
                                            checked: localSettingsData.value.closedWeekdays[5],
                                            name: "weekday-start",
                                            type: "checkbox"
                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_93),
                                        _cache[165] || (_cache[165] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_94, [
                                        _cache[166] || (_cache[166] = (0, vue_2.createElementVNode)("span", null, "土", -1 /* CACHED */)),
                                        (0, vue_2.createElementVNode)("input", {
                                            onChange: _cache[33] || (_cache[33] = ($event) => (handleCloseDaysChange($event, (0, vue_2.unref)(dateInt_1.default).SAT))),
                                            checked: localSettingsData.value.closedWeekdays[6],
                                            name: "weekday-start",
                                            type: "checkbox"
                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_95),
                                        _cache[167] || (_cache[167] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                    ])
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" Change Shift button in Modal "),
                            (0, vue_2.createElementVNode)("div", _hoisted_96, [
                                _cache[179] || (_cache[179] = (0, vue_2.createElementVNode)("div", { class: "settings-item-name-wrapper flex-center" }, [
                                    (0, vue_2.createElementVNode)("span", { class: "settings-item-name text-wrap" }, [
                                        (0, vue_2.createTextVNode)("ボタン"),
                                        (0, vue_2.createElementVNode)("br"),
                                        (0, vue_2.createTextVNode)("のテキスト")
                                    ])
                                ], -1 /* CACHED */)),
                                (0, vue_2.createElementVNode)("div", _hoisted_97, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_98, [
                                        (0, vue_2.createCommentVNode)(" shiftWorkText "),
                                        (0, vue_2.createElementVNode)("label", _hoisted_99, [
                                            _cache[169] || (_cache[169] = (0, vue_2.createElementVNode)("span", { class: "text-success" }, "○", -1 /* CACHED */)),
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event) => ((localSettingsData.value.shiftWorkText) = $event)),
                                                class: "form-input form-small",
                                                type: "text"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [vue_2.vModelText, localSettingsData.value.shiftWorkText]
                                            ]),
                                            _cache[170] || (_cache[170] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_100, [
                                        (0, vue_2.createCommentVNode)(" shiftOffText "),
                                        (0, vue_2.createElementVNode)("label", _hoisted_101, [
                                            _cache[171] || (_cache[171] = (0, vue_2.createElementVNode)("span", null, [
                                                (0, vue_2.createElementVNode)("i", { class: "zmdi zmdi-close zmdi-hc-lg text-error" })
                                            ], -1 /* CACHED */)),
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event) => ((localSettingsData.value.shiftOffText) = $event)),
                                                class: "form-input form-small",
                                                type: "text"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [vue_2.vModelText, localSettingsData.value.shiftOffText]
                                            ]),
                                            _cache[172] || (_cache[172] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_102, [
                                        (0, vue_2.createCommentVNode)(" shiftPTOText "),
                                        (0, vue_2.createElementVNode)("label", _hoisted_103, [
                                            _cache[173] || (_cache[173] = (0, vue_2.createElementVNode)("span", { class: "text-error" }, "有休", -1 /* CACHED */)),
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event) => ((localSettingsData.value.shiftPTOText) = $event)),
                                                class: "form-input form-small",
                                                type: "text"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [vue_2.vModelText, localSettingsData.value.shiftPTOText]
                                            ]),
                                            _cache[174] || (_cache[174] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_104, [
                                        (0, vue_2.createCommentVNode)(" shiftHalfPTOText "),
                                        (0, vue_2.createElementVNode)("label", _hoisted_105, [
                                            _cache[175] || (_cache[175] = (0, vue_2.createElementVNode)("span", { class: "text-error" }, "半有休", -1 /* CACHED */)),
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event) => ((localSettingsData.value.shiftHalfPTOText) = $event)),
                                                class: "form-input form-small",
                                                type: "text"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [vue_2.vModelText, localSettingsData.value.shiftHalfPTOText]
                                            ]),
                                            _cache[176] || (_cache[176] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_106, [
                                        (0, vue_2.createCommentVNode)(" shiftStaffOffText "),
                                        (0, vue_2.createElementVNode)("label", _hoisted_107, [
                                            _cache[177] || (_cache[177] = (0, vue_2.createElementVNode)("span", { class: "text-error" }, "希望休", -1 /* CACHED */)),
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event) => ((localSettingsData.value.shiftStaffOffText) = $event)),
                                                class: "form-input form-small",
                                                type: "text"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [vue_2.vModelText, localSettingsData.value.shiftStaffOffText]
                                            ]),
                                            _cache[178] || (_cache[178] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                        ])
                                    ])
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" Hide Shift button in Modal "),
                            (0, vue_2.createElementVNode)("div", _hoisted_108, [
                                (0, vue_2.createElementVNode)("div", _hoisted_109, [
                                    _cache[181] || (_cache[181] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name text-wrap" }, [
                                        (0, vue_2.createTextVNode)("シフト提出"),
                                        (0, vue_2.createElementVNode)("br"),
                                        (0, vue_2.createTextVNode)("のボタン")
                                    ], -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_110, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[180] || (_cache[180] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "シフト提出のボタンを非表示設定")
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_111, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_112, [
                                        (0, vue_2.createCommentVNode)(" IsHidingTypeOInShiftModal "),
                                        (0, vue_2.createElementVNode)("label", _hoisted_113, [
                                            _cache[182] || (_cache[182] = (0, vue_2.createElementVNode)("span", { class: "text-success" }, "○", -1 /* CACHED */)),
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event) => ((localSettingsData.value.isHidingTypeOInShiftModal) = $event)),
                                                type: "checkbox"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [vue_2.vModelCheckbox, localSettingsData.value.isHidingTypeOInShiftModal]
                                            ]),
                                            _cache[183] || (_cache[183] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_114, [
                                        (0, vue_2.createCommentVNode)(" IsHidingTypeXInShiftModal "),
                                        (0, vue_2.createElementVNode)("label", _hoisted_115, [
                                            _cache[184] || (_cache[184] = (0, vue_2.createElementVNode)("span", null, [
                                                (0, vue_2.createElementVNode)("i", { class: "zmdi zmdi-close zmdi-hc-lg text-error" })
                                            ], -1 /* CACHED */)),
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event) => ((localSettingsData.value.isHidingTypeXInShiftModal) = $event)),
                                                type: "checkbox"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [vue_2.vModelCheckbox, localSettingsData.value.isHidingTypeXInShiftModal]
                                            ]),
                                            _cache[185] || (_cache[185] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_116, [
                                        (0, vue_2.createCommentVNode)(" IsHidingTypePTOInShiftModal "),
                                        (0, vue_2.createElementVNode)("label", _hoisted_117, [
                                            _cache[186] || (_cache[186] = (0, vue_2.createElementVNode)("span", { class: "text-error" }, "有休", -1 /* CACHED */)),
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event) => ((localSettingsData.value.isHidingTypePTOInShiftModal) = $event)),
                                                type: "checkbox"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [vue_2.vModelCheckbox, localSettingsData.value.isHidingTypePTOInShiftModal]
                                            ]),
                                            _cache[187] || (_cache[187] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_118, [
                                        (0, vue_2.createCommentVNode)(" IsHidingTypeHalfPTOInShiftModal "),
                                        (0, vue_2.createElementVNode)("label", _hoisted_119, [
                                            _cache[188] || (_cache[188] = (0, vue_2.createElementVNode)("span", { class: "text-error" }, "半有休", -1 /* CACHED */)),
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event) => ((localSettingsData.value.isHidingTypeHalfPTOInShiftModal) = $event)),
                                                type: "checkbox"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [vue_2.vModelCheckbox, localSettingsData.value.isHidingTypeHalfPTOInShiftModal]
                                            ]),
                                            _cache[189] || (_cache[189] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_120, [
                                        (0, vue_2.createCommentVNode)(" IsHidingTypePublicHolidayInShiftModal "),
                                        (0, vue_2.createElementVNode)("label", _hoisted_121, [
                                            _cache[190] || (_cache[190] = (0, vue_2.createElementVNode)("span", { class: "text-error" }, "法定休日", -1 /* CACHED */)),
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event) => ((localSettingsData.value.isHidingTypePublicHolidayInShiftModal) = $event)),
                                                type: "checkbox"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [vue_2.vModelCheckbox, localSettingsData.value.isHidingTypePublicHolidayInShiftModal]
                                            ]),
                                            _cache[191] || (_cache[191] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_122, [
                                        (0, vue_2.createCommentVNode)(" IsHidingTypeOtherHolidayInShiftModal "),
                                        (0, vue_2.createElementVNode)("label", _hoisted_123, [
                                            _cache[192] || (_cache[192] = (0, vue_2.createElementVNode)("span", { class: "text-error" }, "法定外休日", -1 /* CACHED */)),
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event) => ((localSettingsData.value.isHidingTypeOtherHolidayInShiftModal) = $event)),
                                                type: "checkbox"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [vue_2.vModelCheckbox, localSettingsData.value.isHidingTypeOtherHolidayInShiftModal]
                                            ]),
                                            _cache[193] || (_cache[193] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                        ])
                                    ])
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" Hide Form Fields in Modal "),
                            (0, vue_2.createElementVNode)("div", _hoisted_124, [
                                (0, vue_2.createElementVNode)("div", _hoisted_125, [
                                    _cache[195] || (_cache[195] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name text-wrap" }, [
                                        (0, vue_2.createTextVNode)("シフト提出"),
                                        (0, vue_2.createElementVNode)("br"),
                                        (0, vue_2.createTextVNode)("の自由入力")
                                    ], -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_126, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[194] || (_cache[194] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "シフト提出の自由入力欄を非表示設定")
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_127, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_128, [
                                        (0, vue_2.createCommentVNode)(" isHidingPurposeInShiftModal "),
                                        (0, vue_2.createElementVNode)("label", _hoisted_129, [
                                            _cache[196] || (_cache[196] = (0, vue_2.createElementVNode)("span", null, "ラベル", -1 /* CACHED */)),
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event) => ((localSettingsData.value.isHidingPurposeInShiftModal) = $event)),
                                                type: "checkbox"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [vue_2.vModelCheckbox, localSettingsData.value.isHidingPurposeInShiftModal]
                                            ]),
                                            _cache[197] || (_cache[197] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_130, [
                                        (0, vue_2.createCommentVNode)(" isHidingFromInShiftModal "),
                                        (0, vue_2.createElementVNode)("label", _hoisted_131, [
                                            _cache[198] || (_cache[198] = (0, vue_2.createElementVNode)("span", null, "から", -1 /* CACHED */)),
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event) => ((localSettingsData.value.isHidingFromInShiftModal) = $event)),
                                                type: "checkbox"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [vue_2.vModelCheckbox, localSettingsData.value.isHidingFromInShiftModal]
                                            ]),
                                            _cache[199] || (_cache[199] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_132, [
                                        (0, vue_2.createCommentVNode)(" isHidingToInShiftModal "),
                                        (0, vue_2.createElementVNode)("label", _hoisted_133, [
                                            _cache[200] || (_cache[200] = (0, vue_2.createElementVNode)("span", null, "まで", -1 /* CACHED */)),
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event) => ((localSettingsData.value.isHidingToInShiftModal) = $event)),
                                                type: "checkbox"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [vue_2.vModelCheckbox, localSettingsData.value.isHidingToInShiftModal]
                                            ]),
                                            _cache[201] || (_cache[201] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_134, [
                                        (0, vue_2.createCommentVNode)(" isHidingMemoInShiftModal "),
                                        (0, vue_2.createElementVNode)("label", _hoisted_135, [
                                            _cache[202] || (_cache[202] = (0, vue_2.createElementVNode)("span", null, "メモ", -1 /* CACHED */)),
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event) => ((localSettingsData.value.isHidingMemoInShiftModal) = $event)),
                                                type: "checkbox"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [vue_2.vModelCheckbox, localSettingsData.value.isHidingMemoInShiftModal]
                                            ]),
                                            _cache[203] || (_cache[203] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_136, [
                                        (0, vue_2.createCommentVNode)(" isHidingRestInShiftModal "),
                                        (0, vue_2.createElementVNode)("label", _hoisted_137, [
                                            _cache[204] || (_cache[204] = (0, vue_2.createElementVNode)("span", null, "休憩時間", -1 /* CACHED */)),
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event) => ((localSettingsData.value.isHidingRestInShiftModal) = $event)),
                                                type: "checkbox"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [vue_2.vModelCheckbox, localSettingsData.value.isHidingRestInShiftModal]
                                            ]),
                                            _cache[205] || (_cache[205] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_138, [
                                        (0, vue_2.createCommentVNode)(" isHidingCommentInputInShiftModal "),
                                        (0, vue_2.createElementVNode)("label", _hoisted_139, [
                                            _cache[206] || (_cache[206] = (0, vue_2.createElementVNode)("span", null, "コメント機能", -1 /* CACHED */)),
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event) => ((localSettingsData.value.isHidingCommentInputInShiftModal) = $event)),
                                                type: "checkbox"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [vue_2.vModelCheckbox, localSettingsData.value.isHidingCommentInputInShiftModal]
                                            ]),
                                            _cache[207] || (_cache[207] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                        ])
                                    ])
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" IsHidingRoleInStaffModal "),
                            (0, vue_2.createElementVNode)("div", _hoisted_140, [
                                (0, vue_2.createElementVNode)("div", _hoisted_141, [
                                    _cache[209] || (_cache[209] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "業務を非表示", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_142, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[208] || (_cache[208] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "シフト提出の業務を非表示")
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_143, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event) => ((localSettingsData.value.isHidingRoleInStaffModal) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.isHidingRoleInStaffModal]
                                    ]),
                                    _cache[210] || (_cache[210] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" shiftNotification "),
                            (0, vue_2.createElementVNode)("div", _hoisted_144, [
                                (0, vue_2.createElementVNode)("div", _hoisted_145, [
                                    _cache[212] || (_cache[212] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "前通知", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_146, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[211] || (_cache[211] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "出勤前の事前確認通知")
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (!(0, vue_2.unref)(hasProPerm))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_147))
                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                (0, vue_2.createElementVNode)("label", {
                                    class: (0, vue_2.normalizeClass)(["form-label settings-input", disabledBtn.value])
                                }, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event) => ((shiftNotification).value = $event)),
                                        class: "form-input oplus-input-time",
                                        type: "time"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelText, shiftNotification.value]
                                    ])
                                ], 2 /* CLASS */)
                            ]),
                            (0, vue_2.createCommentVNode)(" startOfWeek "),
                            (0, vue_2.createElementVNode)("div", _hoisted_148, [
                                _cache[227] || (_cache[227] = (0, vue_2.createElementVNode)("div", { class: "settings-item-name-wrapper flex-center" }, [
                                    (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "週始め")
                                ], -1 /* CACHED */)),
                                (0, vue_2.createElementVNode)("div", _hoisted_149, [
                                    (0, vue_2.createElementVNode)("label", _hoisted_150, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event) => ((localSettingsData.value.weekStart) = $event)),
                                            value: (0, vue_2.unref)(dateInt_1.default).SUN,
                                            type: "radio",
                                            name: "default-start-weekday"
                                        }, null, 8 /* PROPS */, _hoisted_151), [
                                            [vue_2.vModelRadio, localSettingsData.value.weekStart]
                                        ]),
                                        _cache[213] || (_cache[213] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */)),
                                        _cache[214] || (_cache[214] = (0, vue_2.createElementVNode)("span", null, "日", -1 /* CACHED */))
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_152, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event) => ((localSettingsData.value.weekStart) = $event)),
                                            value: (0, vue_2.unref)(dateInt_1.default).MON,
                                            type: "radio",
                                            name: "default-start-weekday"
                                        }, null, 8 /* PROPS */, _hoisted_153), [
                                            [vue_2.vModelRadio, localSettingsData.value.weekStart]
                                        ]),
                                        _cache[215] || (_cache[215] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */)),
                                        _cache[216] || (_cache[216] = (0, vue_2.createElementVNode)("span", null, "月", -1 /* CACHED */))
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_154, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event) => ((localSettingsData.value.weekStart) = $event)),
                                            value: (0, vue_2.unref)(dateInt_1.default).TUE,
                                            type: "radio",
                                            name: "default-start-weekday"
                                        }, null, 8 /* PROPS */, _hoisted_155), [
                                            [vue_2.vModelRadio, localSettingsData.value.weekStart]
                                        ]),
                                        _cache[217] || (_cache[217] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */)),
                                        _cache[218] || (_cache[218] = (0, vue_2.createElementVNode)("span", null, "火", -1 /* CACHED */))
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_156, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event) => ((localSettingsData.value.weekStart) = $event)),
                                            value: (0, vue_2.unref)(dateInt_1.default).WED,
                                            type: "radio",
                                            name: "default-start-weekday"
                                        }, null, 8 /* PROPS */, _hoisted_157), [
                                            [vue_2.vModelRadio, localSettingsData.value.weekStart]
                                        ]),
                                        _cache[219] || (_cache[219] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */)),
                                        _cache[220] || (_cache[220] = (0, vue_2.createElementVNode)("span", null, "水", -1 /* CACHED */))
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_158, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event) => ((localSettingsData.value.weekStart) = $event)),
                                            value: (0, vue_2.unref)(dateInt_1.default).THUR,
                                            type: "radio",
                                            name: "default-start-weekday"
                                        }, null, 8 /* PROPS */, _hoisted_159), [
                                            [vue_2.vModelRadio, localSettingsData.value.weekStart]
                                        ]),
                                        _cache[221] || (_cache[221] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */)),
                                        _cache[222] || (_cache[222] = (0, vue_2.createElementVNode)("span", null, "木", -1 /* CACHED */))
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_160, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event) => ((localSettingsData.value.weekStart) = $event)),
                                            value: (0, vue_2.unref)(dateInt_1.default).FRI,
                                            type: "radio",
                                            name: "default-start-weekday"
                                        }, null, 8 /* PROPS */, _hoisted_161), [
                                            [vue_2.vModelRadio, localSettingsData.value.weekStart]
                                        ]),
                                        _cache[223] || (_cache[223] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */)),
                                        _cache[224] || (_cache[224] = (0, vue_2.createElementVNode)("span", null, "金", -1 /* CACHED */))
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_162, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event) => ((localSettingsData.value.weekStart) = $event)),
                                            value: (0, vue_2.unref)(dateInt_1.default).SAT,
                                            type: "radio",
                                            name: "default-start-weekday"
                                        }, null, 8 /* PROPS */, _hoisted_163), [
                                            [vue_2.vModelRadio, localSettingsData.value.weekStart]
                                        ]),
                                        _cache[225] || (_cache[225] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */)),
                                        _cache[226] || (_cache[226] = (0, vue_2.createElementVNode)("span", null, "土", -1 /* CACHED */))
                                    ])
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" Summary Day Start * End "),
                            (0, vue_2.createElementVNode)("div", _hoisted_164, [
                                _cache[231] || (_cache[231] = (0, vue_2.createElementVNode)("div", { class: "settings-item-name-wrapper flex-center" }, [
                                    (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "就業時間設定")
                                ], -1 /* CACHED */)),
                                (0, vue_2.createElementVNode)("label", _hoisted_165, [
                                    (0, vue_2.createElementVNode)("input", {
                                        onChange: handleSummaryDayStartChange,
                                        value: localSettingsData.value.summaryDayStart,
                                        class: "form-input form-extra-small",
                                        type: "text",
                                        placeholder: "1"
                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_166),
                                    _cache[228] || (_cache[228] = (0, vue_2.createElementVNode)("span", null, "時", -1 /* CACHED */)),
                                    _cache[229] || (_cache[229] = (0, vue_2.createTextVNode)(" 〜 ", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("input", {
                                        onChange: handleSummaryDayEndChange,
                                        value: localSettingsData.value.summaryDayEnd,
                                        class: "form-input form-extra-small",
                                        type: "text",
                                        placeholder: "24"
                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_167),
                                    _cache[230] || (_cache[230] = (0, vue_2.createElementVNode)("span", null, "時", -1 /* CACHED */))
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" startOfMonth "),
                            (0, vue_2.createElementVNode)("div", _hoisted_168, [
                                _cache[233] || (_cache[233] = (0, vue_2.createElementVNode)("div", { class: "settings-item-name-wrapper flex-center" }, [
                                    (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "月始めの日")
                                ], -1 /* CACHED */)),
                                (0, vue_2.createElementVNode)("label", _hoisted_169, [
                                    (0, vue_2.createElementVNode)("input", {
                                        onChange: handleStartOfMonthChange,
                                        value: localSettingsData.value.monthStart,
                                        class: "form-input form-small",
                                        type: "text",
                                        placeholder: "1"
                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_170),
                                    _cache[232] || (_cache[232] = (0, vue_2.createElementVNode)("span", null, "日", -1 /* CACHED */))
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" startOfYear "),
                            (0, vue_2.createElementVNode)("div", _hoisted_171, [
                                _cache[235] || (_cache[235] = (0, vue_2.createElementVNode)("div", { class: "settings-item-name-wrapper flex-center" }, [
                                    (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "年始めの月")
                                ], -1 /* CACHED */)),
                                (0, vue_2.createElementVNode)("label", _hoisted_172, [
                                    (0, vue_2.createElementVNode)("input", {
                                        onChange: handleStartOfYearChange,
                                        value: localSettingsData.value.yearStart,
                                        class: "form-input form-small",
                                        type: "text",
                                        placeholder: "12"
                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_173),
                                    _cache[234] || (_cache[234] = (0, vue_2.createElementVNode)("span", null, "月", -1 /* CACHED */))
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" requestOff "),
                            (0, vue_2.createElementVNode)("div", _hoisted_174, [
                                (0, vue_2.createElementVNode)("div", _hoisted_175, [
                                    _cache[237] || (_cache[237] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "シフトの公休", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_176, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[236] || (_cache[236] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "スタッフが出した公休が「希望休」として表示される。")
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (!(0, vue_2.unref)(hasProPerm))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_177))
                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                (0, vue_2.createElementVNode)("label", {
                                    class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledBtn.value])
                                }, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event) => ((localSettingsData.value.requestOff) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.requestOff]
                                    ]),
                                    _cache[238] || (_cache[238] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                ], 2 /* CLASS */)
                            ]),
                            (0, vue_2.createCommentVNode)(" roleRequestOff "),
                            (0, vue_2.createElementVNode)("div", _hoisted_178, [
                                (0, vue_2.createElementVNode)("div", _hoisted_179, [
                                    _cache[240] || (_cache[240] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "業務の公休", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_180, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[239] || (_cache[239] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "スタッフが出した業務の公休が「希望休」として表示される。")
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (!(0, vue_2.unref)(hasProPerm))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_181))
                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                (0, vue_2.createElementVNode)("label", {
                                    class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledBtn.value])
                                }, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event) => ((localSettingsData.value.roleRequestOff) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.roleRequestOff]
                                    ]),
                                    _cache[241] || (_cache[241] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                ], 2 /* CLASS */)
                            ]),
                            (0, vue_2.createCommentVNode)(" hideTimeLess "),
                            (0, vue_2.createElementVNode)("div", _hoisted_182, [
                                (0, vue_2.createElementVNode)("div", _hoisted_183, [
                                    _cache[243] || (_cache[243] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "「○ x 有休」", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_184, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[242] || (_cache[242] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, [
                                                (0, vue_2.createElementVNode)("span", null, "「○」"),
                                                (0, vue_2.createElementVNode)("span", null, "「×」"),
                                                (0, vue_2.createElementVNode)("span", null, "「有休」"),
                                                (0, vue_2.createTextVNode)("のボタンを非表示にする。 ")
                                            ])
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (!(0, vue_2.unref)(hasProPerm))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_185))
                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                (0, vue_2.createElementVNode)("label", {
                                    class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledBtn.value])
                                }, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event) => ((localSettingsData.value.hideTimeLess) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.hideTimeLess]
                                    ]),
                                    _cache[244] || (_cache[244] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                ], 2 /* CLASS */)
                            ]),
                            (0, vue_2.createCommentVNode)(" staffLock "),
                            (0, vue_2.createElementVNode)("div", _hoisted_186, [
                                (0, vue_2.createElementVNode)("div", _hoisted_187, [
                                    _cache[246] || (_cache[246] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "スタッフロック", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_188, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[245] || (_cache[245] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "管理者が確定した日までのシフトは追加・編集が出来なくなる。")
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (!(0, vue_2.unref)(hasProPerm))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_189))
                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                (0, vue_2.createElementVNode)("label", {
                                    class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledBtn.value])
                                }, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event) => ((localSettingsData.value.staffLock) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.staffLock]
                                    ]),
                                    _cache[247] || (_cache[247] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                ], 2 /* CLASS */)
                            ]),
                            (0, vue_2.createCommentVNode)(" staffLockedSummary "),
                            (0, vue_2.createElementVNode)("div", _hoisted_190, [
                                (0, vue_2.createElementVNode)("div", _hoisted_191, [
                                    _cache[249] || (_cache[249] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "確定されたシフト", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_192, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[248] || (_cache[248] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "スタッフが確定されたシフトしか見えない。シフト閲覧設定が必要。")
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (!(0, vue_2.unref)(hasProPerm))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_193))
                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                (0, vue_2.createElementVNode)("label", {
                                    class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledBtn.value])
                                }, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event) => ((localSettingsData.value.staffLockedSummary) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.staffLockedSummary]
                                    ]),
                                    _cache[250] || (_cache[250] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                ], 2 /* CLASS */)
                            ]),
                            (0, vue_2.createCommentVNode)(" shiftLockDate "),
                            (0, vue_2.createElementVNode)("div", _hoisted_194, [
                                (0, vue_2.createElementVNode)("div", _hoisted_195, [
                                    _cache[252] || (_cache[252] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "シフトをロック", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_196, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[251] || (_cache[251] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "スタッフのシフトをロック（以下の日にちからシフトを閲覧・提出出来なくする）")
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_197, [
                                    (0, vue_2.createElementVNode)("label", _hoisted_198, [
                                        (0, vue_2.createElementVNode)("input", {
                                            onChange: handleShiftLockYearChange,
                                            value: localSettingShiftLockDate.value.shiftLockYear,
                                            class: "form-input form-small",
                                            type: "text",
                                            placeholder: "2024"
                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_199),
                                        _cache[253] || (_cache[253] = (0, vue_2.createElementVNode)("span", null, "年", -1 /* CACHED */))
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_200, [
                                        (0, vue_2.createElementVNode)("input", {
                                            onChange: handleShiftLockMonthChange,
                                            value: localSettingShiftLockDate.value.shiftLockMonth,
                                            class: "form-input form-extra-small",
                                            type: "text",
                                            placeholder: "1"
                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_201),
                                        _cache[254] || (_cache[254] = (0, vue_2.createElementVNode)("span", null, "月", -1 /* CACHED */))
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_202, [
                                        (0, vue_2.createElementVNode)("input", {
                                            onChange: handleShiftLockDayChange,
                                            value: localSettingShiftLockDate.value.shiftLockDay,
                                            class: "form-input form-extra-small",
                                            type: "text",
                                            placeholder: "1"
                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_203),
                                        _cache[255] || (_cache[255] = (0, vue_2.createElementVNode)("span", null, "日", -1 /* CACHED */))
                                    ])
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" maxConsecutiveWorkdays "),
                            (0, vue_2.createElementVNode)("div", _hoisted_204, [
                                (0, vue_2.createElementVNode)("div", _hoisted_205, [
                                    _cache[257] || (_cache[257] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "連勤アラート", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_206, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[256] || (_cache[256] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "連勤より多い場合アラート")
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_207, [
                                    (0, vue_2.createElementVNode)("input", {
                                        onChange: handleMaxConsecutiveWorkdays,
                                        class: "form-input form-small",
                                        value: localSettingsData.value.maxConsecutiveWorkdays,
                                        type: "text",
                                        placeholder: "5"
                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_208),
                                    _cache[258] || (_cache[258] = (0, vue_2.createElementVNode)("span", null, "日間", -1 /* CACHED */))
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" maxConsecutiveDaysOff "),
                            (0, vue_2.createElementVNode)("div", _hoisted_209, [
                                (0, vue_2.createElementVNode)("div", _hoisted_210, [
                                    _cache[260] || (_cache[260] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "連休アラート", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_211, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[259] || (_cache[259] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "連休より多い場合アラート")
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_212, [
                                    (0, vue_2.createElementVNode)("input", {
                                        onChange: handleMaxConsecutiveDaysOff,
                                        class: "form-input form-small",
                                        value: localSettingsData.value.maxConsecutiveDaysOff,
                                        type: "text",
                                        placeholder: "5"
                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_213),
                                    _cache[261] || (_cache[261] = (0, vue_2.createElementVNode)("span", null, "日間", -1 /* CACHED */))
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" minVacationWeekly (labor) "),
                            (0, vue_2.createElementVNode)("div", _hoisted_214, [
                                (0, vue_2.createElementVNode)("div", _hoisted_215, [
                                    _cache[263] || (_cache[263] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "労務（週ごと）", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_216, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[262] || (_cache[262] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "週ごとの公休が最低日数に達していなければアラート ")
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_217, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                        "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event) => ((localSettingsData.value.minVacationWeekly) = $event)),
                                        class: "labor-select form-input form-select"
                                    }, [
                                        ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(7, (n) => {
                                            return (0, vue_2.createElementVNode)("option", {
                                                key: n - 1,
                                                value: n - 1
                                            }, (0, vue_2.toDisplayString)(n - 1), 9 /* TEXT, PROPS */, _hoisted_218);
                                        }), 64 /* STABLE_FRAGMENT */))
                                    ], 512 /* NEED_PATCH */), [
                                        [vue_2.vModelSelect, localSettingsData.value.minVacationWeekly]
                                    ])
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" minVacationMonthly (labor) "),
                            (0, vue_2.createElementVNode)("div", _hoisted_219, [
                                (0, vue_2.createElementVNode)("div", _hoisted_220, [
                                    _cache[265] || (_cache[265] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "労務（月ごと）", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_221, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[264] || (_cache[264] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "月ごとの公休が最低日数に達していなければアラート ")
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_222, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                        "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event) => ((localSettingsData.value.minVacationMonthly) = $event)),
                                        class: "labor-select form-input form-select"
                                    }, [
                                        ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(32, (n) => {
                                            return (0, vue_2.createElementVNode)("option", {
                                                key: n - 1,
                                                value: n - 1
                                            }, (0, vue_2.toDisplayString)(n - 1), 9 /* TEXT, PROPS */, _hoisted_223);
                                        }), 64 /* STABLE_FRAGMENT */))
                                    ], 512 /* NEED_PATCH */), [
                                        [vue_2.vModelSelect, localSettingsData.value.minVacationMonthly]
                                    ])
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" maxWorkDaysPerMonth "),
                            (__props.isDefaultSettingsPage)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_224, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_225, [
                                        _cache[267] || (_cache[267] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "月最大出勤数", -1 /* CACHED */)),
                                        (0, vue_2.createElementVNode)("div", _hoisted_226, [
                                            (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                            _cache[266] || (_cache[266] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                                (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "全スタッフの月間出勤日数の上限を設定する（基準20日、最大26日）")
                                            ], -1 /* CACHED */))
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_227, [
                                        _cache[269] || (_cache[269] = (0, vue_2.createElementVNode)("span", { class: "settings-max-label" }, "MAX", -1 /* CACHED */)),
                                        (0, vue_2.createElementVNode)("div", _hoisted_228, [
                                            (0, vue_2.createElementVNode)("input", {
                                                value: localSettingsData.value.maxWorkDaysPerMonth,
                                                onInput: _cache[67] || (_cache[67] = ($event) => (localSettingsData.value.maxWorkDaysPerMonth = Number($event.target.value))),
                                                class: "form-input labor-day-input",
                                                type: "number",
                                                min: "0",
                                                max: "26",
                                                placeholder: "0"
                                            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_229),
                                            _cache[268] || (_cache[268] = (0, vue_2.createElementVNode)("span", { class: "labor-day-suffix" }, "日", -1 /* CACHED */))
                                        ])
                                    ])
                                ]))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            (0, vue_2.createCommentVNode)(" maxVacationMonthly "),
                            (__props.isDefaultSettingsPage)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_230, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_231, [
                                        _cache[271] || (_cache[271] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "月最大休日数", -1 /* CACHED */)),
                                        (0, vue_2.createElementVNode)("div", _hoisted_232, [
                                            (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                            _cache[270] || (_cache[270] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                                (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, " 全スタッフの月間休日数の上限を設定する")
                                            ], -1 /* CACHED */))
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_233, [
                                        _cache[273] || (_cache[273] = (0, vue_2.createElementVNode)("span", { class: "settings-max-label" }, "MAX", -1 /* CACHED */)),
                                        (0, vue_2.createElementVNode)("div", _hoisted_234, [
                                            (0, vue_2.createElementVNode)("input", {
                                                value: localSettingsData.value.maxVacationMonthly,
                                                onInput: _cache[68] || (_cache[68] = ($event) => (localSettingsData.value.maxVacationMonthly = Number($event.target.value))),
                                                class: "form-input labor-day-input",
                                                type: "number",
                                                min: "0",
                                                max: "31",
                                                placeholder: "0"
                                            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_235),
                                            _cache[272] || (_cache[272] = (0, vue_2.createElementVNode)("span", { class: "labor-day-suffix" }, "日", -1 /* CACHED */))
                                        ])
                                    ])
                                ]))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            (0, vue_2.createCommentVNode)(" maxWorkDaysPerWeek "),
                            (__props.isDefaultSettingsPage)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_236, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_237, [
                                        _cache[275] || (_cache[275] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "週最大出勤数", -1 /* CACHED */)),
                                        (0, vue_2.createElementVNode)("div", _hoisted_238, [
                                            (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                            _cache[274] || (_cache[274] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                                (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "全スタッフの週間出勤日数の上限を設定する（基準5日、最大6日）")
                                            ], -1 /* CACHED */))
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_239, [
                                        _cache[277] || (_cache[277] = (0, vue_2.createElementVNode)("span", { class: "settings-max-label" }, "MAX", -1 /* CACHED */)),
                                        (0, vue_2.createElementVNode)("div", _hoisted_240, [
                                            (0, vue_2.createElementVNode)("input", {
                                                value: localSettingsData.value.maxWorkDaysPerWeek,
                                                onInput: _cache[69] || (_cache[69] = ($event) => (localSettingsData.value.maxWorkDaysPerWeek = Number($event.target.value))),
                                                class: "form-input labor-day-input",
                                                type: "number",
                                                min: "0",
                                                max: "6",
                                                placeholder: "0"
                                            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_241),
                                            _cache[276] || (_cache[276] = (0, vue_2.createElementVNode)("span", { class: "labor-day-suffix" }, "日", -1 /* CACHED */))
                                        ])
                                    ])
                                ]))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            (0, vue_2.createCommentVNode)(" maxWeekLaborMinutes "),
                            (__props.isDefaultSettingsPage)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_242, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_243, [
                                        _cache[279] || (_cache[279] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "週最大労務", -1 /* CACHED */)),
                                        (0, vue_2.createElementVNode)("div", _hoisted_244, [
                                            (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                            _cache[278] || (_cache[278] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                                (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "全スタッフの週労働時間の上限を設定する（基準40時間、最大51時間25分）")
                                            ], -1 /* CACHED */))
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_245, [
                                        _cache[280] || (_cache[280] = (0, vue_2.createElementVNode)("span", { class: "settings-max-label" }, "MAX", -1 /* CACHED */)),
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event) => ((localSettingsData.value.maxWeekLaborMinutes) = $event)),
                                            class: "form-input form-small",
                                            type: "text",
                                            placeholder: "HH:MM"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelText, localSettingsData.value.maxWeekLaborMinutes]
                                        ])
                                    ])
                                ]))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            (0, vue_2.createCommentVNode)(" maxMonthLaborMinutes "),
                            (__props.isDefaultSettingsPage)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_246, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_247, [
                                        _cache[282] || (_cache[282] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "月最大労務", -1 /* CACHED */)),
                                        (0, vue_2.createElementVNode)("div", _hoisted_248, [
                                            (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                            _cache[281] || (_cache[281] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                                (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "全スタッフの月間労働時間の上限を設定する（基準：160時間，最大：205時間） ")
                                            ], -1 /* CACHED */))
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_249, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event) => ((localSettingsData.value.maxMonthLaborMinutes) = $event)),
                                            id: "max-month-labor-minutes",
                                            class: "max-month-labor-minutes form-input br-5",
                                            type: "text",
                                            placeholder: "HH:MM"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelText, localSettingsData.value.maxMonthLaborMinutes]
                                        ]),
                                        (0, vue_2.createElementVNode)("i", {
                                            class: "zmdi zmdi-calendar-note c-hand",
                                            onClick: handleCalendarClick
                                        })
                                    ])
                                ]))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            (0, vue_2.createCommentVNode)(" overtimeStartTime "),
                            (__props.isDefaultSettingsPage)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_250, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_251, [
                                        _cache[284] || (_cache[284] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "残業起算時間", -1 /* CACHED */)),
                                        (0, vue_2.createElementVNode)("div", _hoisted_252, [
                                            (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                            _cache[283] || (_cache[283] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                                (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "設定した時間を超える勤務に対し、時給の1.25倍の割増賃金を適用する（基準：8時間）")
                                            ], -1 /* CACHED */))
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_253, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event) => ((localSettingsData.value.overtimeStartTime) = $event)),
                                            type: "checkbox"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelCheckbox, localSettingsData.value.overtimeStartTime]
                                        ]),
                                        _cache[285] || (_cache[285] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                    ]),
                                    (localSettingsData.value.overtimeStartTime)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_254, [
                                            (0, vue_2.createElementVNode)("label", _hoisted_255, [
                                                _cache[286] || (_cache[286] = (0, vue_2.createElementVNode)("span", null, "シフト管理で残業が表示される。", -1 /* CACHED */)),
                                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                    "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event) => ((localSettingsData.value.showOvertimeStartTime) = $event)),
                                                    type: "checkbox",
                                                    class: "overtime-start-time-checkbox"
                                                }, null, 512 /* NEED_PATCH */), [
                                                    [vue_2.vModelCheckbox, localSettingsData.value.showOvertimeStartTime]
                                                ])
                                            ]),
                                            (0, vue_2.createElementVNode)("input", {
                                                value: localSettingsData.value.overtimeStartTimeHours,
                                                onInput: handleOvertimeHoursInput,
                                                type: "number",
                                                step: "any",
                                                class: "form-input form-small overtime-start-time-hours-input",
                                                min: "0.5",
                                                max: "24"
                                            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_256),
                                            _cache[287] || (_cache[287] = (0, vue_2.createElementVNode)("span", null, "時間", -1 /* CACHED */))
                                        ]))
                                        : (0, vue_2.createCommentVNode)("v-if", true)
                                ]))
                                : (0, vue_2.createCommentVNode)("v-if", true)
                        ])
                    ]),
                    (0, vue_2.createCommentVNode)(" Plan page settings "),
                    ((0, vue_2.unref)(hasProPerm))
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("details", _hoisted_257, [
                            (0, vue_2.createElementVNode)("summary", _hoisted_258, [
                                _cache[288] || (_cache[288] = (0, vue_2.createElementVNode)("i", { class: "icon icon-arrow-right" }, null, -1 /* CACHED */)),
                                (0, vue_2.createVNode)(PlanManagementIcon_vue_1.default, { class: "page-title-text settings-accordion-icon" }),
                                _cache[289] || (_cache[289] = (0, vue_2.createElementVNode)("span", { class: "page-title-text" }, "計画管理", -1 /* CACHED */))
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_259, [
                                (0, vue_2.createCommentVNode)(" isPlanMemoInSummaryPage "),
                                (0, vue_2.createElementVNode)("div", _hoisted_260, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_261, [
                                        _cache[291] || (_cache[291] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "メモ", -1 /* CACHED */)),
                                        (0, vue_2.createElementVNode)("div", _hoisted_262, [
                                            (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                            _cache[290] || (_cache[290] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                                (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "シフト表にメモを表示")
                                            ], -1 /* CACHED */))
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_263, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event) => ((localSettingsData.value.isPlanMemoInSummaryPage) = $event)),
                                            type: "checkbox"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelCheckbox, localSettingsData.value.isPlanMemoInSummaryPage]
                                        ]),
                                        _cache[292] || (_cache[292] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                    ])
                                ]),
                                (0, vue_2.createCommentVNode)(" isPlanRevenueInSummaryPage "),
                                (0, vue_2.createElementVNode)("div", _hoisted_264, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_265, [
                                        _cache[294] || (_cache[294] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "売り上げ", -1 /* CACHED */)),
                                        (0, vue_2.createElementVNode)("div", _hoisted_266, [
                                            (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                            _cache[293] || (_cache[293] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                                (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "シフト表に売り上げを表示")
                                            ], -1 /* CACHED */))
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_267, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event) => ((localSettingsData.value.isPlanRevenueInSummaryPage) = $event)),
                                            type: "checkbox"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelCheckbox, localSettingsData.value.isPlanRevenueInSummaryPage]
                                        ]),
                                        _cache[295] || (_cache[295] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                    ])
                                ]),
                                (0, vue_2.createCommentVNode)(" isPlanNumEqInSummaryPage "),
                                (0, vue_2.createElementVNode)("div", _hoisted_268, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_269, [
                                        _cache[297] || (_cache[297] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "利用人数", -1 /* CACHED */)),
                                        (0, vue_2.createElementVNode)("div", _hoisted_270, [
                                            (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                            _cache[296] || (_cache[296] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                                (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "シフト表に利用人数を表示")
                                            ], -1 /* CACHED */))
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_271, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event) => ((localSettingsData.value.isPlanNumEqInSummaryPage) = $event)),
                                            type: "checkbox"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelCheckbox, localSettingsData.value.isPlanNumEqInSummaryPage]
                                        ]),
                                        _cache[298] || (_cache[298] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                    ])
                                ]),
                                (0, vue_2.createCommentVNode)(" isPlanNumInSummaryPage "),
                                (0, vue_2.createElementVNode)("div", _hoisted_272, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_273, [
                                        _cache[300] || (_cache[300] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "必要人数", -1 /* CACHED */)),
                                        (0, vue_2.createElementVNode)("div", _hoisted_274, [
                                            (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                            _cache[299] || (_cache[299] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                                (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "シフト表に必要人数を表示")
                                            ], -1 /* CACHED */))
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_275, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event) => ((localSettingsData.value.isPlanNumInSummaryPage) = $event)),
                                            type: "checkbox"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelCheckbox, localSettingsData.value.isPlanNumInSummaryPage]
                                        ]),
                                        _cache[301] || (_cache[301] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                    ])
                                ])
                            ])
                        ]))
                        : (0, vue_2.createCommentVNode)("v-if", true),
                    (0, vue_2.createElementVNode)("details", _hoisted_276, [
                        _cache[318] || (_cache[318] = (0, vue_2.createElementVNode)("summary", { class: "settings-title-wrapper accordion-header c-hand" }, [
                            (0, vue_2.createElementVNode)("i", { class: "icon icon-arrow-right" }),
                            (0, vue_2.createElementVNode)("span", { class: "page-title-text settings-accordion-icon" }, "その他")
                        ], -1 /* CACHED */)),
                        (0, vue_2.createElementVNode)("div", _hoisted_277, [
                            (0, vue_2.createCommentVNode)(" hideLiveChat "),
                            (0, vue_2.createElementVNode)("div", _hoisted_278, [
                                (0, vue_2.createElementVNode)("div", _hoisted_279, [
                                    _cache[303] || (_cache[303] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "サポート", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_280, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[302] || (_cache[302] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "サポートチャットを消す。 (ページを更新する必要があります)")
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_281, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event) => ((localSettingsData.value.hideLiveChat) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.hideLiveChat]
                                    ]),
                                    _cache[304] || (_cache[304] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" staffNoBoard "),
                            (0, vue_2.createElementVNode)("div", _hoisted_282, [
                                (0, vue_2.createElementVNode)("div", _hoisted_283, [
                                    _cache[306] || (_cache[306] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "揭示板", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_284, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[305] || (_cache[305] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "管理者以外が掲示板を作成・コメントできないようにする（閲覧のみ）")
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (!(0, vue_2.unref)(hasProPerm))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_285))
                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                (0, vue_2.createElementVNode)("label", {
                                    class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledBtn.value])
                                }, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event) => ((localSettingsData.value.staffNoBoard) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.staffNoBoard]
                                    ]),
                                    _cache[307] || (_cache[307] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                ], 2 /* CLASS */)
                            ]),
                            (0, vue_2.createCommentVNode)(" AutoConsec "),
                            (0, vue_2.createElementVNode)("div", _hoisted_286, [
                                (0, vue_2.createElementVNode)("div", _hoisted_287, [
                                    _cache[309] || (_cache[309] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "自動作成最大連勤", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_288, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[308] || (_cache[308] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "自動シフト作成の際最大連勤を使う。")
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (!(0, vue_2.unref)(hasAutoPerm))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_289))
                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                (0, vue_2.createElementVNode)("label", {
                                    class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledAuto.value])
                                }, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[80] || (_cache[80] = ($event) => ((localSettingsData.value.autoConsec) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.autoConsec]
                                    ]),
                                    _cache[310] || (_cache[310] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                ], 2 /* CLASS */)
                            ]),
                            (0, vue_2.createCommentVNode)(" AutoConsecDaysOfff "),
                            (0, vue_2.createElementVNode)("div", _hoisted_290, [
                                (0, vue_2.createElementVNode)("div", _hoisted_291, [
                                    _cache[312] || (_cache[312] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "自動作成最大連休", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_292, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[311] || (_cache[311] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "自動シフト作成の際最大連休を使う。")
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (!(0, vue_2.unref)(hasAutoPerm))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_293))
                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                (0, vue_2.createElementVNode)("label", {
                                    class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledAuto.value])
                                }, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[81] || (_cache[81] = ($event) => ((localSettingsData.value.autoConsecDaysOff) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.autoConsecDaysOff]
                                    ]),
                                    _cache[313] || (_cache[313] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                ], 2 /* CLASS */)
                            ]),
                            (0, vue_2.createCommentVNode)(" shiftInterval "),
                            (0, vue_2.createElementVNode)("div", _hoisted_294, [
                                (0, vue_2.createElementVNode)("div", _hoisted_295, [
                                    _cache[315] || (_cache[315] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "インターバル", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_296, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[314] || (_cache[314] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "自動作成時に勤務間インターバルを考慮したシフトを組むことができる")
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (!(0, vue_2.unref)(hasAutoPerm))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_297))
                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                (0, vue_2.createElementVNode)("label", {
                                    class: (0, vue_2.normalizeClass)(["form-label settings-input", disabledAuto.value])
                                }, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[82] || (_cache[82] = ($event) => ((shiftInterval).value = $event)),
                                        class: "form-input oplus-input-time",
                                        type: "time"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelText, shiftInterval.value]
                                    ])
                                ], 2 /* CLASS */)
                            ]),
                            (props.showTzSetting && localSettingsData.value.timeZone)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_298, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_299, [
                                        _cache[317] || (_cache[317] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "Time Zone", -1 /* CACHED */)),
                                        (0, vue_2.createElementVNode)("div", _hoisted_300, [
                                            (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                            _cache[316] || (_cache[316] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                                (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "Set the branch's time zone")
                                            ], -1 /* CACHED */))
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_301, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                            "onUpdate:modelValue": _cache[83] || (_cache[83] = ($event) => ((localSettingsData.value.timeZone) = $event)),
                                            class: "labor-select form-input form-select"
                                        }, [
                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(Intl.supportedValuesOf('timeZone'), (tz) => {
                                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                                    key: tz,
                                                    value: tz
                                                }, (0, vue_2.toDisplayString)(tz), 9 /* TEXT, PROPS */, _hoisted_302));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ], 512 /* NEED_PATCH */), [
                                            [vue_2.vModelSelect, localSettingsData.value.timeZone]
                                        ])
                                    ])
                                ]))
                                : (0, vue_2.createCommentVNode)("v-if", true)
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_303, [
                        (0, vue_2.createElementVNode)("button", {
                            class: (0, vue_2.normalizeClass)(["oplus-modal-btn oplus-alt-confirm-btn oplus-save-btn", loadingClass.value]),
                            onClick: handleShiftSubmit
                        }, "保存", 2 /* CLASS */)
                    ])
                ], 2 /* CLASS */));
        };
    }
});
